import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ManageMasterListsPageComponent } from './manage-master-lists-page.component';
import { TabsModule } from 'ngx-bootstrap';
import { ManageSkillsPageModule } from '../manage-skills-page/manage-skills-page.module';
import { ManageRequisitionEntitiesPageModule } from '../manage-requisition-entities-page/manage-requisition-entities-page.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.masterLists',
    url: '/masterLists',
    component: ManageMasterListsPageComponent,
    data: {
      requireLogin: true
    }
  }
];

@NgModule({
  declarations: [ManageMasterListsPageComponent],
  imports: [
    CommonModule,
    SkeletonLoaderModule,
    TabsModule.forRoot(),
    ManageSkillsPageModule,
    ManageRequisitionEntitiesPageModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [ManageMasterListsPageComponent],
  entryComponents: [ManageMasterListsPageComponent]
})
export class ManageMasterListsPageModule { }
